<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
            
          <!-- <div class="col-sm-12">
             <ValidationProvider
               name="Product Code"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="brand">
                Product Code <span class="required-color">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="brand"
                v-model="productCode"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid product code"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Product Code"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div> -->
          <div class="col-sm-12">
             <ValidationProvider
               name="Product Name"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="brand">
                Product Name <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="brand"
                class="form-control"
                v-model="productName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid product name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Product Name"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-12">
                <ValidationProvider name="brand" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Brand<span class="required-color">*</span></label>
                  <select
                    class="form-control"
                    v-model="brand"
                    name="brand_id"
                    style="width: 100%;"
                  >
                    <option id="brand" selected value=""
                      >Choose Brand</option
                    >
                    <option
                      v-for="brand in brandList"
                      :key="brand.brand_id"
                      v-bind:value="brand.brand_id"
                      >{{ brand.brand_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-12">
                <ValidationProvider name="category" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Category<span class="required-color">*</span></label>
                  <select
                    class="form-control"
                    v-model="category"
                    name="category_id"
                    style="width: 100%;"
                  >
                    <option id="category" selected value=""
                      >Choose Category</option
                    >
                    <option
                      v-for="category in categoryList"
                      :key="category.category_id"
                      v-bind:value="category.category_id"
                      >{{ category.category_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-12">
                <ValidationProvider name="supplier" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Supplier<span class="required-color">*</span></label>    
      <v-select v-model="supplier" label="supplier_name" :options="supplierList"></v-select>
      
                  <!-- <select
                    class="form-control"
                    v-model="supplier"
                    name="supplier_id"
                    style="width: 100%;"
                  >
                    <option id="category" selected value=""
                      >Choose Supplier</option
                    >
                    <option
                      v-for="vendor in supplierList"
                      :key="vendor.supplier_id"
                      v-bind:value="vendor.supplier_id"
                      >{{ vendor.supplier_name }}</option
                    >
                  </select> -->
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-12">
                <ValidationProvider name="uom" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Measure Unit<span class="required-color">*</span></label>
                  <select
                    class="form-control"
                    v-model="uom"
                    name="uom_id"
                    style="width: 100%;"
                  >
                    <option id="brand" selected value=""
                      >Choose UOM</option
                    >
                    <option
                      v-for="uom in uomList"
                      :key="uom.uom_id"
                      v-bind:value="uom.uom_id"
                      >{{ uom.uom_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-12">
             <ValidationProvider
               name="Price"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="price">
                Price <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="price"
                class="form-control"
                v-model="productPrice"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid price"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Price"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <div class="col-sm-12">
             <ValidationProvider
               name="Product Description"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="brand">
                Product Description <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="brand"
                class="form-control"
                v-model="productDescription"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid product description"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Product Description"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  props: ["productId"],
  name: "AddProduct",
  data() {
    return {
      saveCat: false,
      itemId: '',
      brand: '',
      category: '',
      supplier: '',
      uom: '',
      productCode: '',
      productName: '',
      productPrice: '',
      productDescription: '',
      brandList: [],
      uomList: [],
      categoryList: [],
      supplierList: [],
      errors : [],
      loading: false,
    };
  },
  components: {vSelect},
  methods: {
    getBrands: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_brands", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.brandList = response.data.values;
          } else {
            this.brandList = data.brandList;
          }
        });
    },
    getUOM: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_uom", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.uomList = response.data.values;
          } else {
            this.uomList = data.uomList;
          }
        });
    },
    getCategory: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_category", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.categoryList = response.data.values;
          } else {
            this.categoryList = data.categoryList;
          }
        });
    },
    getSupplier: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_suppliers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.supplierList = response.data.values;
          } else {
            this.supplierList = data.supplierList;
            this.supplier = this.supplierList.find(obj => { return obj.supplier_id == this.supplier.supplier_id; });
          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.productId;
      this.errors = []
      if (!this.productName) {
        this.errors.push("Invested Product Name is required.");
      }
      if (!this.brand) {
        this.errors.push("Brand is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "product-form": {
          brand_id: this.brand,
          product_id: this.itemId,
          product_name: this.productName,
          product_description: this.productDescription,
          product_code: this.productCode,
          supplier_id: this.supplier.supplier_id,
          price: this.productPrice,
          category_id: this.category,
          uom_id: this.uom
        },
      };
      if (this.itemId > 0) {
        api
          .request("post", "GeneralApis/edit_product", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_product", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getProduct: function() {
      var product_id = this.$props.productId;
        (this.productCode = ""),
        (this.productName = ""),
        (this.productDescription = ""),
        (this.productPrice = ""),
        (this.itemId = 0);
      if (product_id > 0) {
        this.itemId = product_id;

        const getItem = {
          filter: {
            product_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_products", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const productList = data.productList[0];
              this.productCode = productList.product_code;
              this.productName = productList.product_name;
              this.productDescription = productList.product_description;
              this.brand = productList.brand_id;
              this.uom = productList.uom_id;
              this.category = productList.category_id;
              this.supplier = {supplier_id:productList.supplier_id};
              this.productPrice = productList.price;
            }
          });
      }
    },
  },
  mounted() {
    this.getBrands();
    this.getProduct();
    this.getCategory();
    this.getSupplier();
    this.getUOM();
  },
};
</script>
